import {TZ_TO_IANA_TZ} from 'core/utils/timezone'
import * as React from 'react'
import {Dispatch} from 'react-redux'
import {reduxForm} from 'redux-form'
import * as Features from 'study_coordinator/features'
import {addSubjectRequest} from 'study_coordinator/store'
import {randomHexOfLength} from 'study_coordinator/utils/random'
import {createValidator, required, integer, npiValidator} from 'core/validation'
import {IFormFields, IProps, SubjectFormBase} from './subject-form-base'

const injectPropsToSubjectForm = (
  Component: React.ComponentType<IProps>,
  injectedProps: Partial<IProps>,
) => {
  return class extends React.Component<IProps, {}> {
    public render() {
      return <Component {...injectedProps} {...this.props} />
    }
  }
}

export const createSubjectFormReduxFormComponent = ({
  formName,
}: {
  formName: string,
}) => {
  const initialValues = {
    subjectIdentifier: '',
    age: 4,
    deviceType: 'GEAR_R325_201712',
    timezone: TZ_TO_IANA_TZ.Eastern,
    language: 'en-US',
    partnerOrderId: 'Pending',
  }

  // When subjectIdentifier is generated, there is no need to validate the field.
  // See comments on the generateSubjectIdentifiers feature for details.
  // const subjectIdentifierValidators = Features.generateSubjectIdentifiers()
  //   ? []
  //   : [required, regex(/^[0-9]{3}$/, '001')]
  const propsToInject = Features.generateSubjectIdentifiers()
    ? {
      subjectIdentifierAllowedInput: undefined,
      subjectIdentifierDisabled: true,
    }
    : {
      subjectIdentifierAllowedInput: /\d/,
      subjectIdentifierDisabled: false,
    }
  const onSubmit = (data: IFormFields, dispatch: Dispatch<void>) => {
    const subjectIdentifier = Features.generateSubjectIdentifiers()
      ? randomHexOfLength(8) // maximum length allowed by backend
      : data.subjectIdentifier
    const subjectRequest = {
      ...data,
      subjectIdentifier,
      isSimpleMode: data.age <= 5,
    }
    dispatch(addSubjectRequest(subjectRequest, formName))
  }

  const formDecorator = reduxForm<IFormFields, IProps, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: (values, props) => {
      return createValidator({
        prescribingNpi: [required, integer, npiValidator(10)],
      })(values)
    },
    enableReinitialize: true,
  })

  const InjectedSubjectForm = injectPropsToSubjectForm(SubjectFormBase, propsToInject)
  const DecoratedSubjectForm = formDecorator(InjectedSubjectForm)
  return DecoratedSubjectForm
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-form/subject-form-redux-form.tsx